import * as Constants from "../../utils/constants";

export const profileImageSet = (data: any) => {
  return {
    type: Constants.PROFILE_IMAGE_SET,
    payload: data,
  };
};

export const MyLoadCard = () => ({
  type: Constants.MYLOAD_CARD_DATA,
});

export const GetMyLoadCardData = (data: any) => ({
  type: Constants.GET_MYLOAD_CARD_DATA,
  payload: data,
});

export const confirmStartInformation = (
  data: any,
  callback: (shipment: any) => void
) => ({
  type: Constants.CarrierActionTypes.CONFIRM_START_INFORMATION,
  payload: {
    data,
    callback,
  },
});

export const confirmStartInformationSuccess = (data: any) => ({
  type: Constants.CarrierActionTypes.CONFIRM_START_INFORMATION_SUCCESS,
  payload: data,
});

export const confirmStartInformationStatusMessage = (data: any) => ({
  type: Constants.CarrierActionTypes.CONFIRM_START_INFORMATION_STATUS_MESSAGE,
  payload: data,
});

export const showWarningDialog = (message: string ) => ({
  type: Constants.CarrierActionTypes.SHOW_WARNING_DIALOG,
  payload: {
    message
  },
});

export const clearWarningDialog = () => ({
  type: Constants.CarrierActionTypes.CLEAR_WARNING_DIALOG
});


export const clearConfirmStartInformationStatusMessage = () => ({
  type:
    Constants.CarrierActionTypes.CLEAR_CONFIRM_START_INFORMATION_STATUS_MESSAGE,
});

export const updateStopInformation = (data: any, callBack: Function) => ({
  type: Constants.CarrierActionTypes.UPDATE_STOP_INFORMATION,
  payload: {
    data,
    callBack,
  },
});

export const updateStopInformationResponse = (data: any) => ({
  type: Constants.CarrierActionTypes.UPDATE_STOP_INFORMATION_RESPONSE,
  payload: data,
});

export const clearUpdateStopInformationResponse = () => ({
  type: Constants.CarrierActionTypes.CLEAR_UPDATE_STOP_INFORMATION_RESPONSE
});

export const getTmsDocumentRequest = (data:any) => ({
  type: Constants.GET_TMS_DOCUMENT,
  payload: data,
});

export const getTmsDocumentsRequest = (data:any) => ({
  type: Constants.GET_TMS_DOCUMENTS,
  payload: data,
});

export const saveTmsDocument = (data:any) => ({
  type: Constants.SAVE_TMS_DOCUMENTS,
  payload: data,
});
export const createInvoice = (data:any) => ({
  type: Constants.CREATE_INVOICE,
  payload: data,
});
export const submitInvoice = (data:any) => ({
  type: Constants.SUBMIT_INVOICE,
  payload: data,
});
export const saveTmsDocumentNew = (data:any) => ({
  type: Constants.SAVE_TMS_DOCUMENTS_NEW,
  payload: data,
});
export const submitInvoiceNew = (data:any) => ({
  type: Constants.SUBMIT_INVOICE_NEW,
  payload: data,
});
export const storeCapturedImage = (data:any) => ({
  type: Constants.STORE_CAPTURE_IMAGE,
  payload: data,
});
export const clearCapturedImage = () => ({
  type: Constants.REMOVE_CAPTURE_IMAGE,
});
export const updateGPSInformation = (data: any, callback: Function) => ({
  type: Constants.CarrierActionTypes.UPDATE_GPS_STATUS,
  payload: {
    data,
    callback
  },
});

export const contactUsDetailsRequest = (data:any) => ({
  type: Constants.CONTACT_US_DETAILS,
  payload: data,
})

export const contactUsDetailsRequestForMobile = (payload:any) => ({
  type: Constants.CONTACT_US_DETAILS,
  payload,
})
